const {
    createEventId,
    recordDiagnostic,
} = require('./diagnostics');

function getDataLayer() {
    window.dataLayer = window.dataLayer || [];

    return window.dataLayer;
}

function pushDataLayerEvent(eventData, context = {}) {
    const eventId = context.eventId || createEventId();
    const eventName = eventData.event || 'unknown';
    const originalCallback = eventData.eventCallback;
    let callbackHandled = false;

    const trackedEvent = Object.assign({}, eventData, {
        eventCallback: function () {
            if (callbackHandled) {
                return;
            }

            callbackHandled = true;

            try {
                if (typeof originalCallback === 'function') {
                    originalCallback();
                }
            } finally {
                recordDiagnostic('gtm_processed', {
                    eventId,
                    eventName,
                    source: context.source,
                    targetPage: context.targetPage,
                });
            }
        },
    });

    // JSON storage omits undefined properties; restore both GTM key shapes on replay.
    if (eventName === 'purchase' || eventName === 'begin_checkout') {
        if (!Object.prototype.hasOwnProperty.call(trackedEvent, 'email')) {
            trackedEvent.email = undefined;
        }
        if (!Object.prototype.hasOwnProperty.call(trackedEvent, 'phone')) {
            trackedEvent.phone = undefined;
        }
        trackedEvent.user_data = Object.assign({
            email_address: trackedEvent.email,
            sha256_email_address: undefined,
            phone_number: trackedEvent.phone,
            sha256_phone_number: undefined,
        }, trackedEvent.user_data || {});
    }

    recordDiagnostic('data_layer_push', {
        eventId,
        eventName,
        source: context.source,
        targetPage: context.targetPage,
    });

    try {
        getDataLayer().push(trackedEvent);
    } catch (error) {
        recordDiagnostic('data_layer_error', {
            eventId,
            eventName,
            source: context.source,
            targetPage: context.targetPage,
        });
        throw error;
    }

    return eventId;
}

module.exports = {
    pushDataLayerEvent,
};
